<template>
    <dash
        icon="fa fa-users"
        titulo="TOTAL DE ACESSOS NO ANO"
        :qtd="qtd"
        :loading="loading"
        color="#63C0F9"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent2'

export default {
	props: {
		qtd: {
			type: Number
		},

		loading: {
			type: Boolean
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
